import { axiosInstance } from ".."



const removeChatMemberList = async (checkItemID,data) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.put(`internal/chat/removemember/${checkItemID}`,data).then((res) => {
            console.log('res__________',res)
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
  }
  
  export default removeChatMemberList;